// @flow
import React from 'react';
import {Text, StyleSheet, View} from 'react-native';
import theme from '../../theme-config';

const PageTitle = ({title, subtitle}: {title: string, subtitle?: string}) => {
  return (
    <View style={styles.container}>
      <Text style={[styles.title]}>{title}</Text>
      {subtitle && <Text style={[styles.subtitle]}>{subtitle}</Text>}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 20,
  },
  title: {
    fontFamily: 'Caveat Brush',
    color: theme.primaryColor,
    textAlign: 'center',
    fontSize: 38,
    lineHeight: 46,
  },
  subtitle: {
    fontFamily: 'Caveat Brush',
    color: theme.primaryColor,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 41,
  },
});

export default PageTitle;
